
export default function Introduction() {
  return (
    <section className="py-16 sm:py-20 md:py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 px-2">
            Giới Thiệu Dự Án
          </h2>
          <div className="w-20 sm:w-24 h-1 bg-gradient-to-r from-blue-600 to-blue-400 mx-auto mb-6 sm:mb-8"></div>
        </div>

        <div className="grid md:grid-cols-2 gap-8 sm:gap-10 md:gap-12 items-center">
          <div className="order-2 md:order-1">
            <img 
              src="https://public.readdy.ai/ai/img_res/27f5b420d2682d41ec4eb99278ccd5a3.jpg" 
              alt="Liên Minh Du Lịch Mỹ - Hợp tác chiến lược"
              title="Liên Minh Du Lịch Mỹ"
              className="w-full h-auto rounded-2xl shadow-2xl object-cover object-top"
            />
          </div>

          <div className="space-y-5 sm:space-y-6 order-1 md:order-2">
            <div className="flex items-start gap-3 sm:gap-4">
              <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-blue-100 rounded-full flex-shrink-0">
                <i className="ri-team-line text-blue-600 text-xl sm:text-2xl"></i>
              </div>
              <div>
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2">Liên Minh Mạnh Mẽ</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  Tập hợp các công ty du lịch, đại lý, đối tác du học – định cư cùng phát triển sản phẩm Mỹ chuyên sâu
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3 sm:gap-4">
              <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-blue-100 rounded-full flex-shrink-0">
                <i className="ri-share-line text-blue-600 text-xl sm:text-2xl"></i>
              </div>
              <div>
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2">Chia Sẻ Tài Nguyên</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  Chia sẻ tài nguyên – hình ảnh – nội dung – kinh nghiệm vận hành để cùng nhau phát triển bền vững
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3 sm:gap-4">
              <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-blue-100 rounded-full flex-shrink-0">
                <i className="ri-trophy-line text-blue-600 text-xl sm:text-2xl"></i>
              </div>
              <div>
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2">Thương Hiệu Giấc Mơ Mỹ</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  Xây dựng thương hiệu <strong>Giấc Mơ Mỹ</strong> thành tiêu chuẩn mới của thị trường du lịch Việt Nam
                </p>
              </div>
            </div>

            <div className="pt-4 sm:pt-6">
              <a 
                href="#partnership" 
                className="inline-block w-full sm:w-auto text-center px-6 sm:px-8 py-3 sm:py-4 bg-blue-600 text-white text-sm sm:text-base font-semibold rounded-full hover:bg-blue-700 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                Tìm Hiểu Dự Án
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}